const defaultCreateContract =
    "<p><strong>Entre {{company}}, [legalStatus] au capital de [shareCapital] €, dont le siège social est sis au [address], [postalCode] [city], représentée par [INDIQUER LE REPRÉSENTANT ICI], son président et directeur des publications, [« l'Éditeur »]</strong></p><p><br></p><p><strong>Et {{name}} qui réside au {{address}}, [« l'Auteur »]</strong></p><p><br></p><p><span class='center' style='text-align: center'><u><strong>IL A ÉTÉ CONVENU CE QUI SUIT</strong></u></span></p><p></p><p><br><strong>Article 1 : Objet du contrat</strong></p><p>Conformément à l’article L.132-7 du Code de la Propriété Intellectuelle, l’Auteur cède à l’Éditeur les droits d’auteur de l'œuvre de l’esprit originale (au sens des articles L 112-2 ou L 112-3 du Code de la Propriété Intellectuelle) référencé dans le relevé annexé au présent contrat sous le numéro :</p><p><br></p><p><span class='center' style='text-align: center'><strong>{{reference}}</strong></span></p><p></p><p><br><strong>Article 2 : Nature de la collaboration</strong></p><p>L’Auteur reconnaît par le présent contrat que son travail de création s’inscrit dans une démarche collective, son œuvre s’intégrant dans une publication comprenant une pluralité d’auteurs.</p><p></p><p><br>L’Auteur reconnaît par ailleurs qu’il n’est soumis à aucun lien de subordination à l’encontre de l’Éditeur. De son côté, l’Éditeur reconnaît qu’il n’est lié à l’Auteur par aucun engagement sur la durée, et qu’il se réserve le droit d’accepter ou non toute oeuvre réalisée et proposée par l’Auteur.</p><p></p><p><br>L’Auteur réalise ladite œuvre, dans son domaine de compétence technique spécifique et dans l’indépendance qu’implique tout travail de recherche et d’écriture.</p><p></p><p><br>L’Auteur travaille avec son propre matériel et sans être tenu à aucun horaire précis, aucune présence ou passage régulier dans les locaux de la société. Il reconnait par conséquent n’être soumis à aucun lien de subordination à l’encontre de l’Éditeur. De son côté, l’Éditeur reconnaît qu’il n’est lié à l’Auteur par aucun engagement sur la durée, et qu’il se réserve le droit d’accepter ou non tout texte réalisé et proposé par l’Auteur.</p><p></p><p><br>L’Auteur déclare par ailleurs ne pas être un journaliste professionnel tel que défini par l’article L7111-3 du Code du travail. S'il le devient en cours de collaboration, il s’engage à en informer l’Éditeur sans délai. Les Parties rediscuteront alors et au besoin des termes de leur collaboration. Le non-respect par l’Auteur de ces stipulations contractuelles et substancielles constituera un juste motif d’interruption de la collaboration et donnera lieu au profit de l’Editeur à des dommages-intérêts équivalent au préjudice subi.</p><p></p><p><br><strong>Article 3 : Cession des droits d’auteur</strong></p><p>Sous réserve des dispositions de l’article L 121-8 du Code de la Propriété Intellectuelle, les droits d’exploitation de ladite œuvre sont cédés à titre exclusif à l’Éditeur, sans limites temporelles ou géographiques autres que celles fixées par les lois françaises et étrangères ainsi que les conventions internationales actuelles et futures, y compris les prorogations qui pourraient être apportées à cette durée. Les droits patrimoniaux cédés comprennent notamment :</p><ul><li>le droit de fixer cette œuvre par toute technique et sur tout support ;</li><li>le droit de reproduire cette œuvre en un nombre illimité d’exemplaires de chaque support ;</li><li>le droit de distribuer cette œuvre et de les communiquer par toute technique de communication ;</li><li>le droit de traduire ou de faire traduire cette œuvre en toutes les langues ;</li><li>le droit d’exploiter cette œuvre pour tous pays, sur tous supports et par tous procédés actuels ou futurs ;</li><li>le droit d’adapter ou de faire adapter cette œuvre en ce compris la reproduction dans une autre œuvre et les adaptations nécessaires à cette intégration, et le droit de faire modifier cette œuvre suivant différents paramètres (tels que la longueur, la typographie, la présentation des notes de bas de page, le(s) titre(s), les adaptations mineures de contenu, le format, ainsi que la couleur, la taille, la résolution (dpi) des éléments graphiques, etc.). L’Auteur renonce expressément à invoquer son droit moral en vue de s’opposer à ces modifications signifiées préalablement à la publication de l'oeuvre, sauf s’il démontre que la modification en cause est préjudiciable à son honneur ou à sa réputation, ou encore si cette modification altère le sens de ses écrits.</li></ul><p></p><p><br><strong>Article 4 : Rémunération</strong></p><p>En contrepartie de la cession de ladite œuvre et des droits sur celle-ci tels que définis ci-dessus, et conformément à l’article L 131-4 du Code de la propriété intellectuelle, l’Éditeur a versé à l’Auteur une rémunération forfaitaire.</p><p><br></p><p><span class='center' style='text-align: center'><strong>Cette rémunération s'élève à {{payment}} €.</strong></span></p><p><br>Cette rémunération comprend le prix de la création et de la réalisation de ladite œuvre, en ce compris tous les frais nécessaires pour sa réalisation, et la rémunération due en vertu de la cession de la propriété de ladite œuvre et des droits d’auteur. Aucun autre montant, pour quelque cause que ce soit, ne pourra être réclamé à l’Éditeur.</p><p><br><strong>Article 5 : Garanties</strong></p><p>L’Éditeur garantie l’édition de ladite œuvre et sa diffusion au sein de la publication mentionnée sur le relevé identifé ci- dessus et annexé au présent contrat (cf. relevé ci-joint), au plus tard 6 mois après la livraison de ladite œuvre, sauf délai supplémentaire consenti par l’Auteur.</p><p><br>Pour sa part, l’Auteur garantit expressément que ladite œuvre n’a pas été réalisée en contravention des droits d’un tiers, et notamment qu’elle ne comprent aucun élément sur lequel un tiers pourrait faire valoir un droit d’auteur ou tout autre droit. Pour sa part, l'Auteur indique à l'Éditeur les sources qu'il utilise dans l'optique du respect des droits des tiers.</p><p></p><p><br>L’Auteur garantit à l’Éditeur la jouissance entière et libre des droits cédés contre tous troubles, revendications et évictions quelconques. Il déclare que son œuvre est entièrement originale et ne contient aucun texte ou illustration susceptible d’engager la responsabilité de l’Éditeur. Il déclare expressément disposer des droits cédés par le présent contrat et précise que ladite œuvre n’a fait l’objet ni d’un autre contrat encore valable ni d’un droit de préférence consenti dans le cadre de l’article L 132-4 du Code de la Propriété Intellectuelle.</p><p></p><p><br>L’Auteur garantit également que ladite œuvre ne contient rien qui puisse tomber sous le coup des lois relatives à la diffamation, l’atteinte aux bonne moeurs ou à la contrefaçon, et en outre il s’engage à ne faire aucune critique de procédés industriels, aucune louange à caractère commercial, qui puisse mettre en cause la responsabilité de l’Éditeur.</p><p></p><p><br>Lorsque l’Auteur intègre des documents iconographiques à son œuvre, il garantit à l’Éditeur que les documents d’illustration qu’il remet sont libres de tous droits et qu’ils ne portent pas atteinte à la vie privée des tiers concernés.</p><p></p><p><br><strong>Article 6 : Validité du contrat, droit applicable et compétence juridictionnelle</strong></p><p>Le présent contrat est soumis au droit français. En cas de litige, seuls les tribunaux du siège social de l'Éditeur sont compétents.</p><p></p><p><br>Si une ou plusieurs stipulations dudit contrat sont tenues pour non valides ou déclarées comme telles par une juridiction compétente, les autres stipulations garderont toute leur force et leur portée.</p>";

export const defaultCreateContractBlocksLexical = {
    "root": {
        "children": [
            {
                "children": [
                    {
                        "detail": 0,
                        "format": 1,
                        "mode": "normal",
                        "style": "",
                        "text": "Entre {{company}}, [legalStatus] au capital de [shareCapital] €, dont le siège social est sis au [address], [postalCode] [city], représentée par [INDIQUER LE REPRÉSENTANT ICI], son président et directeur des publications, [« l'Éditeur »]",
                        "type": "text",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1
            },
            {
                "children": [],
                "direction": null,
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1
            },
            {
                "children": [
                    {
                        "detail": 0,
                        "format": 0,
                        "mode": "normal",
                        "style": "",
                        "text": "Et ",
                        "type": "text",
                        "version": 1
                    },
                    {
                        "detail": 0,
                        "format": 0,
                        "mode": "normal",
                        "style": "",
                        "text": "{{name}}",
                        "type": "variable",
                        "version": 1
                    },
                    {
                        "detail": 0,
                        "format": 0,
                        "mode": "normal",
                        "style": "",
                        "text": " qui réside au ",
                        "type": "text",
                        "version": 1
                    },
                    {
                        "detail": 0,
                        "format": 0,
                        "mode": "normal",
                        "style": "",
                        "text": "{{address}}",
                        "type": "variable",
                        "version": 1
                    },
                    {
                        "detail": 0,
                        "format": 0,
                        "mode": "normal",
                        "style": "",
                        "text": ", [« l'Auteur »]",
                        "type": "text",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1
            },
            {
                "children": [],
                "direction": null,
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1
            },
            {
                "children": [
                    {
                        "detail": 0,
                        "format": 9,
                        "mode": "normal",
                        "style": "",
                        "text": "IL A ÉTÉ CONVENU CE QUI SUIT",
                        "type": "text",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1
            },
            {
                "children": [],
                "direction": null,
                "format": "",
                "indent": 0,
                "type": "paragraph",
                "version": 1
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Article 1",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": ".\t",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Objet du contrat",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-title",
                        "version": 1,
                        "show": true
                    },
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Conformément à l’article L.132-7 du Code de la Propriété Intellectuelle, l’Auteur cède à l’Éditeur les droits d’auteur de l'œuvre de l’esprit originale (au sens des articles L 112-2 ou L 112-3 du Code de la Propriété Intellectuelle) référencé dans le relevé annexé au présent contrat sous le numéro :",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [],
                                "direction": null,
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "{{reference}}",
                                        "type": "variable",
                                        "version": 1
                                    },
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-content",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "article-container",
                "version": 1,
                "open": true,
                "index": [
                    1
                ],
                "referenceKey": "",
                "show": true,
                "conditional": false
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Article 2",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": ".\t",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Nature de la collaboration",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-title",
                        "version": 1,
                        "show": true
                    },
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur reconnaît par le présent contrat que son travail de création s’inscrit dans une démarche collective, son œuvre s’intégrant dans une publication comprenant une pluralité d’auteurs.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur reconnaît par ailleurs qu’il n’est soumis à aucun lien de subordination à l’encontre de l’Éditeur. De son côté, l’Éditeur reconnaît qu’il n’est lié à l’Auteur par aucun engagement sur la durée, et qu’il se réserve le droit d’accepter ou non toute oeuvre réalisée et proposée par l’Auteur.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur réalise ladite œuvre, dans son domaine de compétence technique spécifique et dans l’indépendance qu’implique tout travail de recherche et d’écriture.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur travaille avec son propre matériel et sans être tenu à aucun horaire précis, aucune présence ou passage régulier dans les locaux de la société. Il reconnait par conséquent n’être soumis à aucun lien de subordination à l’encontre de l’Éditeur. De son côté, l’Éditeur reconnaît qu’il n’est lié à l’Auteur par aucun engagement sur la durée, et qu’il se réserve le droit d’accepter ou non tout texte réalisé et proposé par l’Auteur.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur déclare par ailleurs ne pas être un journaliste professionnel tel que défini par l’article L7111-3 du Code du travail. S'il le devient en cours de collaboration, il s’engage à en informer l’Éditeur sans délai. Les Parties rediscuteront alors et au besoin des termes de leur collaboration. Le non-respect par l’Auteur de ces stipulations contractuelles et substancielles constituera un juste motif d’interruption de la collaboration et donnera lieu au profit de l’Editeur à des dommages-intérêts équivalent au préjudice subi.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-content",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "article-container",
                "version": 1,
                "open": true,
                "index": [
                    2
                ],
                "referenceKey": "",
                "show": true,
                "conditional": false
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Article 3",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": ".\t",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Cession des droits d’auteur",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-title",
                        "version": 1,
                        "show": true
                    },
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Sous réserve des dispositions de l’article L 121-8 du Code de la Propriété Intellectuelle, les droits d’exploitation de ladite œuvre sont cédés à titre exclusif à l’Éditeur, sans limites temporelles ou géographiques autres que celles fixées par les lois françaises et étrangères ainsi que les conventions internationales actuelles et futures, y compris les prorogations qui pourraient être apportées à cette durée. Les droits patrimoniaux cédés comprennent notamment :",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "children": [
                                            {
                                                "detail": 0,
                                                "format": 0,
                                                "mode": "normal",
                                                "style": "",
                                                "text": "le droit de fixer cette œuvre par toute technique et sur tout support ;",
                                                "type": "text",
                                                "version": 1
                                            }
                                        ],
                                        "direction": "ltr",
                                        "format": "",
                                        "indent": 0,
                                        "type": "listitem",
                                        "version": 1,
                                        "value": 1
                                    },
                                    {
                                        "children": [
                                            {
                                                "detail": 0,
                                                "format": 0,
                                                "mode": "normal",
                                                "style": "",
                                                "text": "le droit de reproduire cette œuvre en un nombre illimité d’exemplaires de chaque support ;",
                                                "type": "text",
                                                "version": 1
                                            }
                                        ],
                                        "direction": "ltr",
                                        "format": "",
                                        "indent": 0,
                                        "type": "listitem",
                                        "version": 1,
                                        "value": 2
                                    },
                                    {
                                        "children": [
                                            {
                                                "detail": 0,
                                                "format": 0,
                                                "mode": "normal",
                                                "style": "",
                                                "text": "le droit de distribuer cette œuvre et de les communiquer par toute technique de communication ;",
                                                "type": "text",
                                                "version": 1
                                            }
                                        ],
                                        "direction": "ltr",
                                        "format": "",
                                        "indent": 0,
                                        "type": "listitem",
                                        "version": 1,
                                        "value": 3
                                    },
                                    {
                                        "children": [
                                            {
                                                "detail": 0,
                                                "format": 0,
                                                "mode": "normal",
                                                "style": "",
                                                "text": "le droit de traduire ou de faire traduire cette œuvre en toutes les langues ;",
                                                "type": "text",
                                                "version": 1
                                            }
                                        ],
                                        "direction": "ltr",
                                        "format": "",
                                        "indent": 0,
                                        "type": "listitem",
                                        "version": 1,
                                        "value": 4
                                    },
                                    {
                                        "children": [
                                            {
                                                "detail": 0,
                                                "format": 0,
                                                "mode": "normal",
                                                "style": "",
                                                "text": "le droit d’exploiter cette œuvre pour tous pays, sur tous supports et par tous procédés actuels ou futurs ;",
                                                "type": "text",
                                                "version": 1
                                            }
                                        ],
                                        "direction": "ltr",
                                        "format": "",
                                        "indent": 0,
                                        "type": "listitem",
                                        "version": 1,
                                        "value": 5
                                    },
                                    {
                                        "children": [
                                            {
                                                "detail": 0,
                                                "format": 0,
                                                "mode": "normal",
                                                "style": "",
                                                "text": "le droit d’adapter ou de faire adapter cette œuvre en ce compris la reproduction dans une autre œuvre et les adaptations nécessaires à cette intégration, et le droit de faire modifier cette œuvre suivant différents paramètres (tels que la longueur, la typographie, la présentation des notes de bas de page, le(s) titre(s), les adaptations mineures de contenu, le format, ainsi que la couleur, la taille, la résolution (dpi) des éléments graphiques, etc.). L’Auteur renonce expressément à invoquer son droit moral en vue de s’opposer à ces modifications signifiées préalablement à la publication de l'oeuvre, sauf s’il démontre que la modification en cause est préjudiciable à son honneur ou à sa réputation, ou encore si cette modification altère le sens de ses écrits.",
                                                "type": "text",
                                                "version": 1
                                            }
                                        ],
                                        "direction": "ltr",
                                        "format": "",
                                        "indent": 0,
                                        "type": "listitem",
                                        "version": 1,
                                        "value": 6
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "list",
                                "version": 1,
                                "listType": "bullet",
                                "start": 1,
                                "tag": "ul"
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-content",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "article-container",
                "version": 1,
                "open": true,
                "index": [
                    3
                ],
                "referenceKey": "",
                "show": true,
                "conditional": false
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Article 4",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": ".\t",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Rémunération",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-title",
                        "version": 1,
                        "show": true
                    },
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "En contrepartie de la cession de ladite œuvre et des droits sur celle-ci tels que définis ci-dessus, et conformément à l’article L 131-4 du Code de la propriété intellectuelle, l’Éditeur a versé à l’Auteur une rémunération forfaitaire.",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Cette rémunération s'élève à ",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "{{payment}}",
                                        "type": "variable",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": " €.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [],
                                "direction": null,
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Cette rémunération comprend le prix de la création et de la réalisation de ladite œuvre, en ce compris tous les frais nécessaires pour sa réalisation, et la rémunération due en vertu de la cession de la propriété de ladite œuvre et des droits d’auteur. Aucun autre montant, pour quelque cause que ce soit, ne pourra être réclamé à l’Éditeur.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-content",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "article-container",
                "version": 1,
                "open": true,
                "index": [
                    4
                ],
                "referenceKey": "",
                "show": true,
                "conditional": false
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Article 5",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": ".\t",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Garanties",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-title",
                        "version": 1,
                        "show": true
                    },
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Éditeur garantie l’édition de ladite œuvre et sa diffusion au sein de la publication mentionnée sur le relevé identifé ci- dessus et annexé au présent contrat (cf. relevé ci-joint), au plus tard 6 mois après la livraison de ladite œuvre, sauf délai supplémentaire consenti par l’Auteur.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Pour sa part, l’Auteur garantit expressément que ladite œuvre n’a pas été réalisée en contravention des droits d’un tiers, et notamment qu’elle ne comprent aucun élément sur lequel un tiers pourrait faire valoir un droit d’auteur ou tout autre droit. Pour sa part, l'Auteur indique à l'Éditeur les sources qu'il utilise dans l'optique du respect des droits des tiers.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur garantit à l’Éditeur la jouissance entière et libre des droits cédés contre tous troubles, revendications et évictions quelconques. Il déclare que son œuvre est entièrement originale et ne contient aucun texte ou illustration susceptible d’engager la responsabilité de l’Éditeur. Il déclare expressément disposer des droits cédés par le présent contrat et précise que ladite œuvre n’a fait l’objet ni d’un autre contrat encore valable ni d’un droit de préférence consenti dans le cadre de l’article L 132-4 du Code de la Propriété Intellectuelle.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "L’Auteur garantit également que ladite œuvre ne contient rien qui puisse tomber sous le coup des lois relatives à la diffamation, l’atteinte aux bonne moeurs ou à la contrefaçon, et en outre il s’engage à ne faire aucune critique de procédés industriels, aucune louange à caractère commercial, qui puisse mettre en cause la responsabilité de l’Éditeur.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Lorsque l’Auteur intègre des documents iconographiques à son œuvre, il garantit à l’Éditeur que les documents d’illustration qu’il remet sont libres de tous droits et qu’ils ne portent pas atteinte à la vie privée des tiers concernés.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-content",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "article-container",
                "version": 1,
                "open": true,
                "index": [
                    5
                ],
                "referenceKey": "",
                "show": true,
                "conditional": false
            },
            {
                "children": [
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Article 6",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": ".\t",
                                        "type": "text",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 1,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Validité du contrat, droit applicable et compétence juridictionnelle",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-title",
                        "version": 1,
                        "show": true
                    },
                    {
                        "children": [
                            {
                                "children": [
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Le présent contrat est soumis au droit français. En cas de litige, seuls les tribunaux du siège social de l'Éditeur sont compétents.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            },
                            {
                                "children": [
                                    {
                                        "type": "linebreak",
                                        "version": 1
                                    },
                                    {
                                        "detail": 0,
                                        "format": 0,
                                        "mode": "normal",
                                        "style": "",
                                        "text": "Si une ou plusieurs stipulations dudit contrat sont tenues pour non valides ou déclarées comme telles par une juridiction compétente, les autres stipulations garderont toute leur force et leur portée.",
                                        "type": "text",
                                        "version": 1
                                    }
                                ],
                                "direction": "ltr",
                                "format": "",
                                "indent": 0,
                                "type": "paragraph",
                                "version": 1
                            }
                        ],
                        "direction": "ltr",
                        "format": "",
                        "indent": 0,
                        "type": "article-content",
                        "version": 1
                    }
                ],
                "direction": "ltr",
                "format": "",
                "indent": 0,
                "type": "article-container",
                "version": 1,
                "open": true,
                "index": [
                    6
                ],
                "referenceKey": "",
                "show": true,
                "conditional": false
            }
        ],
        "direction": "ltr",
        "format": "",
        "indent": 0,
        "type": "root",
        "version": 1
    }
}

export const defaultCreateContractHtmlLexical = "<p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Entre {{company}}, [legalStatus] au capital de [shareCapital] €, dont le siège social est sis au [address], [postalCode] [city], représentée par [INDIQUER LE REPRÉSENTANT ICI], son président et directeur des publications, [« l'Éditeur »]</strong></b></p><p class=\"PlaygroundEditorTheme__paragraph\"><br></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">Et </span><span class=\"PlaygroundEditorTheme__variable\" data-text=\"{{name}}\" data-variable-name=\": Nom\" style=\"white-space: pre-wrap;\">{{name}}</span><span style=\"white-space: pre-wrap;\"> qui réside au </span><span class=\"PlaygroundEditorTheme__variable\" data-text=\"{{address}}\" data-variable-name=\": Adresse\" style=\"white-space: pre-wrap;\">{{address}}</span><span style=\"white-space: pre-wrap;\">, [« l'Auteur »]</span></p><p class=\"PlaygroundEditorTheme__paragraph\"><br></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><u><b><strong class=\"PlaygroundEditorTheme__textBold PlaygroundEditorTheme__textUnderline\" style=\"white-space: pre-wrap;\">IL A ÉTÉ CONVENU CE QUI SUIT</strong></b></u></p><p class=\"PlaygroundEditorTheme__paragraph\"><br></p><details class=\"Article__container\" open=\"true\"><summary class=\"Article__Title\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Article 1</strong></b><span style=\"white-space: pre-wrap;\">.\t</span><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Objet du contrat</strong></b></p></summary><div class=\"Article__content\" data-lexical-article-content=\"true\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">Conformément à l’article L.132-7 du Code de la Propriété Intellectuelle, l’Auteur cède à l’Éditeur les droits d’auteur de l'œuvre de l’esprit originale (au sens des articles L 112-2 ou L 112-3 du Code de la Propriété Intellectuelle) référencé dans le relevé annexé au présent contrat sous le numéro :</span></p><p class=\"PlaygroundEditorTheme__paragraph\"><br></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold PlaygroundEditorTheme__variable\" data-text=\"{{reference}}\" data-variable-name=\"\" style=\"white-space: pre-wrap;\">{{reference}}</strong></b><br></p></div></details><details class=\"Article__container\" open=\"true\"><summary class=\"Article__Title\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Article 2</strong></b><span style=\"white-space: pre-wrap;\">.\t</span><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Nature de la collaboration</strong></b></p></summary><div class=\"Article__content\" data-lexical-article-content=\"true\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">L’Auteur reconnaît par le présent contrat que son travail de création s’inscrit dans une démarche collective, son œuvre s’intégrant dans une publication comprenant une pluralité d’auteurs.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">L’Auteur reconnaît par ailleurs qu’il n’est soumis à aucun lien de subordination à l’encontre de l’Éditeur. De son côté, l’Éditeur reconnaît qu’il n’est lié à l’Auteur par aucun engagement sur la durée, et qu’il se réserve le droit d’accepter ou non toute oeuvre réalisée et proposée par l’Auteur.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">L’Auteur réalise ladite œuvre, dans son domaine de compétence technique spécifique et dans l’indépendance qu’implique tout travail de recherche et d’écriture.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">L’Auteur travaille avec son propre matériel et sans être tenu à aucun horaire précis, aucune présence ou passage régulier dans les locaux de la société. Il reconnait par conséquent n’être soumis à aucun lien de subordination à l’encontre de l’Éditeur. De son côté, l’Éditeur reconnaît qu’il n’est lié à l’Auteur par aucun engagement sur la durée, et qu’il se réserve le droit d’accepter ou non tout texte réalisé et proposé par l’Auteur.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">L’Auteur déclare par ailleurs ne pas être un journaliste professionnel tel que défini par l’article L7111-3 du Code du travail. S'il le devient en cours de collaboration, il s’engage à en informer l’Éditeur sans délai. Les Parties rediscuteront alors et au besoin des termes de leur collaboration. Le non-respect par l’Auteur de ces stipulations contractuelles et substancielles constituera un juste motif d’interruption de la collaboration et donnera lieu au profit de l’Editeur à des dommages-intérêts équivalent au préjudice subi.</span></p></div></details><details class=\"Article__container\" open=\"true\"><summary class=\"Article__Title\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Article 3</strong></b><span style=\"white-space: pre-wrap;\">.\t</span><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Cession des droits d’auteur</strong></b></p></summary><div class=\"Article__content\" data-lexical-article-content=\"true\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">Sous réserve des dispositions de l’article L 121-8 du Code de la Propriété Intellectuelle, les droits d’exploitation de ladite œuvre sont cédés à titre exclusif à l’Éditeur, sans limites temporelles ou géographiques autres que celles fixées par les lois françaises et étrangères ainsi que les conventions internationales actuelles et futures, y compris les prorogations qui pourraient être apportées à cette durée. Les droits patrimoniaux cédés comprennent notamment :</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br></p><ul class=\"PlaygroundEditorTheme__ul\"><li value=\"1\" class=\"PlaygroundEditorTheme__listItem\"><span style=\"white-space: pre-wrap;\">le droit de fixer cette œuvre par toute technique et sur tout support ;</span></li><li value=\"2\" class=\"PlaygroundEditorTheme__listItem\"><span style=\"white-space: pre-wrap;\">le droit de reproduire cette œuvre en un nombre illimité d’exemplaires de chaque support ;</span></li><li value=\"3\" class=\"PlaygroundEditorTheme__listItem\"><span style=\"white-space: pre-wrap;\">le droit de distribuer cette œuvre et de les communiquer par toute technique de communication ;</span></li><li value=\"4\" class=\"PlaygroundEditorTheme__listItem\"><span style=\"white-space: pre-wrap;\">le droit de traduire ou de faire traduire cette œuvre en toutes les langues ;</span></li><li value=\"5\" class=\"PlaygroundEditorTheme__listItem\"><span style=\"white-space: pre-wrap;\">le droit d’exploiter cette œuvre pour tous pays, sur tous supports et par tous procédés actuels ou futurs ;</span></li><li value=\"6\" class=\"PlaygroundEditorTheme__listItem\"><span style=\"white-space: pre-wrap;\">le droit d’adapter ou de faire adapter cette œuvre en ce compris la reproduction dans une autre œuvre et les adaptations nécessaires à cette intégration, et le droit de faire modifier cette œuvre suivant différents paramètres (tels que la longueur, la typographie, la présentation des notes de bas de page, le(s) titre(s), les adaptations mineures de contenu, le format, ainsi que la couleur, la taille, la résolution (dpi) des éléments graphiques, etc.). L’Auteur renonce expressément à invoquer son droit moral en vue de s’opposer à ces modifications signifiées préalablement à la publication de l'oeuvre, sauf s’il démontre que la modification en cause est préjudiciable à son honneur ou à sa réputation, ou encore si cette modification altère le sens de ses écrits.</span></li></ul></div></details><details class=\"Article__container\" open=\"true\"><summary class=\"Article__Title\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Article 4</strong></b><span style=\"white-space: pre-wrap;\">.\t</span><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Rémunération</strong></b></p></summary><div class=\"Article__content\" data-lexical-article-content=\"true\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">En contrepartie de la cession de ladite œuvre et des droits sur celle-ci tels que définis ci-dessus, et conformément à l’article L 131-4 du Code de la propriété intellectuelle, l’Éditeur a versé à l’Auteur une rémunération forfaitaire.</span><br></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Cette rémunération s'élève à </strong></b><b><strong class=\"PlaygroundEditorTheme__textBold PlaygroundEditorTheme__variable\" data-text=\"{{payment}}\" data-variable-name=\"\" style=\"white-space: pre-wrap;\">{{payment}}</strong></b><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\"> €.</strong></b></p><p class=\"PlaygroundEditorTheme__paragraph\"><br></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">Cette rémunération comprend le prix de la création et de la réalisation de ladite œuvre, en ce compris tous les frais nécessaires pour sa réalisation, et la rémunération due en vertu de la cession de la propriété de ladite œuvre et des droits d’auteur. Aucun autre montant, pour quelque cause que ce soit, ne pourra être réclamé à l’Éditeur.</span></p></div></details><details class=\"Article__container\" open=\"true\"><summary class=\"Article__Title\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Article 5</strong></b><span style=\"white-space: pre-wrap;\">.\t</span><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Garanties</strong></b></p></summary><div class=\"Article__content\" data-lexical-article-content=\"true\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">L’Éditeur garantie l’édition de ladite œuvre et sa diffusion au sein de la publication mentionnée sur le relevé identifé ci- dessus et annexé au présent contrat (cf. relevé ci-joint), au plus tard 6 mois après la livraison de ladite œuvre, sauf délai supplémentaire consenti par l’Auteur.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">Pour sa part, l’Auteur garantit expressément que ladite œuvre n’a pas été réalisée en contravention des droits d’un tiers, et notamment qu’elle ne comprent aucun élément sur lequel un tiers pourrait faire valoir un droit d’auteur ou tout autre droit. Pour sa part, l'Auteur indique à l'Éditeur les sources qu'il utilise dans l'optique du respect des droits des tiers.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">L’Auteur garantit à l’Éditeur la jouissance entière et libre des droits cédés contre tous troubles, revendications et évictions quelconques. Il déclare que son œuvre est entièrement originale et ne contient aucun texte ou illustration susceptible d’engager la responsabilité de l’Éditeur. Il déclare expressément disposer des droits cédés par le présent contrat et précise que ladite œuvre n’a fait l’objet ni d’un autre contrat encore valable ni d’un droit de préférence consenti dans le cadre de l’article L 132-4 du Code de la Propriété Intellectuelle.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">L’Auteur garantit également que ladite œuvre ne contient rien qui puisse tomber sous le coup des lois relatives à la diffamation, l’atteinte aux bonne moeurs ou à la contrefaçon, et en outre il s’engage à ne faire aucune critique de procédés industriels, aucune louange à caractère commercial, qui puisse mettre en cause la responsabilité de l’Éditeur.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">Lorsque l’Auteur intègre des documents iconographiques à son œuvre, il garantit à l’Éditeur que les documents d’illustration qu’il remet sont libres de tous droits et qu’ils ne portent pas atteinte à la vie privée des tiers concernés.</span></p></div></details><details class=\"Article__container\" open=\"true\"><summary class=\"Article__Title\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Article 6</strong></b><span style=\"white-space: pre-wrap;\">.\t</span><b><strong class=\"PlaygroundEditorTheme__textBold\" style=\"white-space: pre-wrap;\">Validité du contrat, droit applicable et compétence juridictionnelle</strong></b></p></summary><div class=\"Article__content\" data-lexical-article-content=\"true\"><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><span style=\"white-space: pre-wrap;\">Le présent contrat est soumis au droit français. En cas de litige, seuls les tribunaux du siège social de l'Éditeur sont compétents.</span></p><p class=\"PlaygroundEditorTheme__paragraph\" dir=\"ltr\"><br><span style=\"white-space: pre-wrap;\">Si une ou plusieurs stipulations dudit contrat sont tenues pour non valides ou déclarées comme telles par une juridiction compétente, les autres stipulations garderont toute leur force et leur portée.</span></p></div></details>"

export default defaultCreateContract;
